module.exports = __webpack_public_path__ + "static/media/successRegister.e37cbe1b.png";